import { Box, Typography, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import moment from "moment";

const DynamicFormChanges = ({ forms }: { forms: any[] }) => {
  if (!forms?.length) return null;
  const formatDisplayValue = (val: any) => {
    if (Array.isArray(val)) {
      return val.map((v) => formatDisplayValue(v.value)).join(", ");
    }
    if (!val) return "N/A";
    if (moment(val, moment.ISO_8601, true).isValid()) {
      return moment(val).format("DD/MM/YYYY");
    }
    return val;
  };

  return (
    <Box sx={{ mt: 2 }}>
      {forms.map((formGroup, idx) => {
        if (!(formGroup?.changes || []).length) return null;

        return (
          <Box key={idx} sx={{ mb: 3 }}>
            {/* Group Title */}
            <Typography
              variant="h6"
              style={{ color: "#fff", background: "#5569ff", padding: "5px" }}
            >
              {formGroup.groupName || "N/A"}
            </Typography>

            {/* Changes Table */}
            <Table size="small">
              <TableHead>
                <TableRow sx={{ background: "#f5f5f5" }}>
                  <TableCell style={{ width: "470px" }}>Field</TableCell>
                  <TableCell style={{ width: "250px" }}>Old Value</TableCell>
                  <TableCell style={{ width: "250px" }}>New Value</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {formGroup.changes.map((change: any, i: number) => {
                  const oldVal = formatDisplayValue(change.oldValue);
                  const newVal = formatDisplayValue(change.newValue);
                  const isChanged = oldVal !== newVal;

                  return (
                    <TableRow key={i}>
                      <TableCell>{change.label || "N/A"}</TableCell>

                      <TableCell>
                        {isChanged ? (
                          <span style={{ color: "red", textDecoration: "line-through" }}>
                            {oldVal}
                          </span>
                        ) : (
                          oldVal
                        )}
                      </TableCell>

                      <TableCell>
                        {isChanged ? (
                          <span style={{ color: "green", fontWeight: 600 }}>{newVal}</span>
                        ) : (
                          newVal
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
        );
      })}
    </Box>
  );
};

export default DynamicFormChanges;
